(function ($) {
  DJ.addBehavior('mimSchoolAboutSlider', '.mim-school-about__slider', {
    attach: function () {
      const slider = this;
      const $slider = $(slider);
      const sliderTimer = slider.getAttribute('data-slider-timer') || 5000;
      let currentBreakpoint = DJ.bp.name;

      /**
       * Build slider.
       */
      const buildSlider = () => {
        if (!slider.getAttribute('data-slider-init')) {
          $slider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: sliderTimer,
            pauseOnHover: true,
            pauseOnFocus: true,
            pauseOnDotsHover: true,
            useCSS: false
          });

          slider.setAttribute('data-slider-init', 'true');
        }
      };

      /**
       * Destroy slider (if it's initialized).
       */
      const destroySlider = () => {
        if (slider.getAttribute('data-slider-init')) {
          $slider.slick('unslick');
          slider.removeAttribute('data-slider-init');
        }
      };

      /**
       * Init slider only if mobile version.
       */
      const checkSlider = () => {
        if (DJ.bp.name === 'mobile') {
          buildSlider();
        } else {
          destroySlider();
        }
      };

      /**
       * init/destroy slider depends on window size(desktop/mobile).
       */
      $(window).resize(function () {
        clearTimeout(window.resizedFinished);

        window.resizedFinished = setTimeout(function () {
          if (currentBreakpoint !== DJ.bp.name) {
            checkSlider();
            currentBreakpoint = DJ.bp.name;
          }
        }, 500);
      });

      checkSlider();
    }
  });
})(jQuery);
